import { createFileRoute } from '@tanstack/react-router';
import {
  createPermissionGuard,
  getPermissionSet,
  MIGRATION_INCONSISTENCY_PERMISSIONS,
  MigrationInconsistenciesView,
} from '@bmwe/ui';

export const Route = createFileRoute('/verwaltung/migrationsfehler/')({
  component: MigrationInconsistenciesView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(MIGRATION_INCONSISTENCY_PERMISSIONS, 'READ'),
  ),
});

export const MigrationInconsistenciesRoute = Route;
